import { ENDPOINT, HTTP } from "../config"
import { fetchFromLawfeed } from "../fetchFromLawfeed"

const getChat = async (userId) => {
  try {
    console.log("Obteniendo chats para el usuario:", userId)

    const response = await fetchFromLawfeed({
      method: HTTP.GET,
      endpoint: ENDPOINT.ALL_CHATS,
      routeParams: [userId],
    })

    console.log("Respuesta completa de la API:", response)

    // Si la respuesta es directamente un array, devuélvelo
    if (Array.isArray(response)) {
      return response
    }

    // Si la respuesta tiene una propiedad 'data' que es un array, úsala
    if (response?.data && Array.isArray(response.data)) {
      return response.data
    }

    console.error("La API no devolvió un array:", response)
    return []
  } catch (error) {
    console.error("Error al obtener chats:", error)
    return []
  }
}

export default getChat

